const carousel = Symbol('carousel')
export { carousel as default }
